import { action } from 'typesafe-actions';

import { DatesTypes } from './types';

// Set Selected Start Date
export const setSelectedStartDate = (payload: { selectedStartDate: Date }) =>
  action(DatesTypes.SET_SELECTED_START_DATE, payload);

// Set Selected End Date
export const setSelectedEndDate = (payload: { selectedEndDate: Date }) =>
  action(DatesTypes.SET_SELECTED_END_DATE, payload);
